import React from 'react';
import PropTypes from 'prop-types';

const Spinner = ({ className, color, size, thickness }) => (
  <div className={`flex items-center justify-center ${className}`}>
    <div className={`animate-spin rounded-full h-${size} w-${size} border-${thickness} border-${color} border-t-transparent`} />
  </div>
);

Spinner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  thickness: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

Spinner.defaultProps = {
  className: '',
  color: 'current',
  size: 5,
  thickness: 2,
};

export default Spinner;
